module.exports = __webpack_public_path__ + "static/media/7.cc08d6b6.png";